import { Linkedin, Twitter, Youtube, Instagram, Mail } from "lucide-react";
import { Reveal } from "./Reveal";
import { Logo } from "./Logo";

const TAGS = ["Trade Shows", "Product Launches", "Corporate Events", "Conventions", "Brand Activations"];

const SOCIALS = [
  { icon: Linkedin, label: "LinkedIn", testid: "social-linkedin" },
  { icon: Twitter, label: "X / Twitter", testid: "social-twitter" },
  { icon: Youtube, label: "YouTube", testid: "social-youtube" },
  { icon: Instagram, label: "Instagram", testid: "social-instagram" },
];

export const Footer = ({ onQuote }) => (
  <footer className="relative border-t border-line" data-testid="site-footer">
    <div className="bg-panel/40 border-b border-line">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24 text-center">
        <Reveal>
          <p className="font-mono text-xs uppercase tracking-[0.3em] text-electric">Final Lap</p>
        </Reveal>
        <Reveal delay={0.08}>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-black uppercase tracking-tight text-slate-50 mt-4">
            Ready to <span className="text-electric">Steal the Show?</span>
          </h2>
        </Reveal>
        <Reveal delay={0.16}>
          <p className="text-base text-slate-400 mt-4 max-w-xl mx-auto">
            Tell us about your event and we'll build a turnkey racing experience your audience won't forget.
          </p>
        </Reveal>
        <Reveal delay={0.24}>
          <button
            onClick={onQuote}
            data-testid="footer-quote-btn"
            className="mt-9 inline-flex items-center bg-electric text-ink font-display font-bold text-sm uppercase tracking-[0.15em] px-8 py-4 clip-corner hover:bg-electric-hover transition-colors duration-200"
          >
            Request a Quote
          </button>
        </Reveal>
      </div>
    </div>

    <div className="border-b border-line">
      <p
        className="text-center font-mono text-[11px] uppercase tracking-[0.35em] text-slate-500 py-5 px-4"
        data-testid="footer-trust-ribbon"
      >
        Trusted by leading brands at major events
      </p>
    </div>

    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 flex flex-col lg:flex-row items-center justify-between gap-8">
      <Logo />
      <div className="flex flex-wrap items-center justify-center gap-x-3 gap-y-2" data-testid="footer-tag-list">
        {TAGS.map((tag, i) => (
          <span key={tag} className="flex items-center gap-3">
            <span className="font-mono text-[11px] uppercase tracking-[0.2em] text-slate-400 hover:text-electric transition-colors cursor-default">
              {tag}
            </span>
            {i < TAGS.length - 1 && <span className="text-electric/50 text-[10px]">|</span>}
          </span>
        ))}
      </div>
      <div className="flex items-center gap-2">
        {SOCIALS.map((s) => (
          <a
            key={s.label}
            href="#top"
            onClick={(e) => e.preventDefault()}
            aria-label={s.label}
            data-testid={s.testid}
            className="h-10 w-10 flex items-center justify-center border border-line text-slate-400 hover:text-electric hover:border-electric/60 transition-colors duration-200"
          >
            <s.icon className="h-4 w-4" strokeWidth={1.8} />
          </a>
        ))}
        <a
          href="mailto:impactactivations1@gmail.com"
          aria-label="Email"
          data-testid="social-email"
          className="h-10 w-10 flex items-center justify-center border border-line text-slate-400 hover:text-electric hover:border-electric/60 transition-colors duration-200"
        >
          <Mail className="h-4 w-4" strokeWidth={1.8} />
        </a>
      </div>
    </div>

    <div className="border-t border-line">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6 flex flex-col sm:flex-row items-center justify-between gap-3">
        <p className="text-xs text-slate-500">© 2026 Impact Activations. All rights reserved.</p>
        <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-600">
          Metro Detroit, Michigan · Racing Simulator Activations
        </p>
      </div>
    </div>
  </footer>
);
